import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import { get_forecast_version } from './utils/global'

// Resolve the 24h forecast version as early as possible: this reads the secret
// query param (if present) on any landing page, persists the pin to the cookie,
// and prints the console banner when a version is pinned. V3 is the default and
// needs no param. See utils/global.js.
get_forecast_version()

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root')
)

// Register service worker for PWA functionality including offline support and auto-updates
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
	onSuccess: (registration) => {
		console.log('Service worker registered successfully')
	},
	onUpdate: (registration) => {
		console.log('New content is available; will update when safe')
		// The serviceWorkerRegistration module handles the update flow
	}
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
